import script from "./StoreCategoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreCategoryList.vue?vue&type=script&setup=true&lang=js"

import "./StoreCategoryList.vue?vue&type=style&index=0&id=3a680c28&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a680c28"]])

export default __exports__